var map = {
	"./book-application/book-application.module": [
		"./src/app/book/book-application/book-application.module.ts",
		"common",
		"book-application.module"
	],
	"./book-cbdk/book-cbdk.module": [
		"./src/app/book/book-cbdk/book-cbdk.module.ts",
		"common",
		"book-cbdk.module"
	],
	"./book-document/book-document.module": [
		"./src/app/book/book-document/book-document.module.ts",
		"common",
		"book-document.module"
	],
	"./book-event-type/book-event-type.module": [
		"./src/app/book/book-event-type/book-event-type.module.ts",
		"common",
		"book-event-type.module"
	],
	"./book-filter/book-filter.module": [
		"./src/app/book/book-filter/book-filter.module.ts",
		"common",
		"book-filter.module"
	],
	"./book-horse-color/book-horse-color.module": [
		"./src/app/book/book-horse-color/book-horse-color.module.ts",
		"common"
	],
	"./book-horse/book-horse.module": [
		"./src/app/book/book-horse/book-horse.module.ts",
		"common",
		"book-horse.module"
	],
	"./book-owner/book-owner.module": [
		"./src/app/book/book-owner/book-owner.module.ts",
		"common"
	],
	"./book-repository/book-repository.module": [
		"./src/app/book/book-repository/book-repository.module.ts",
		"common",
		"book-repository.module"
	],
	"./book-stud-book/book-stud-book.module": [
		"./src/app/book/book-stud-book/book-stud-book.module.ts",
		"common",
		"book-stud-book.module"
	],
	"./book-type/book-type.module": [
		"./src/app/book/book-type/book-type.module.ts",
		"common"
	],
	"./book-veterinarian/book-veterinarian.module": [
		"./src/app/book/book-veterinarian/book-veterinarian.module.ts",
		"common",
		"book-veterinarian.module"
	],
	"./book/book.module": [
		"./src/app/book/book.module.ts",
		"common",
		"book.module"
	],
	"./race-city/race-city.module": [
		"./src/app/race/race-city/race-city.module.ts",
		"common",
		"race-city.module"
	],
	"./race-horse-color/race-horse-color.module": [
		"./src/app/race/race-horse-color/race-horse-color.module.ts",
		"common",
		"race-horse-color.module"
	],
	"./race-horse/race-horse.module": [
		"./src/app/race/race-horse/race-horse.module.ts",
		"common",
		"race-horse.module"
	],
	"./race-jockey/race-jockey.module": [
		"./src/app/race/race-jockey/race-jockey.module.ts",
		"common",
		"race-jockey.module"
	],
	"./race-owner/race-owner.module": [
		"./src/app/race/race-owner/race-owner.module.ts",
		"common",
		"race-owner.module"
	],
	"./race-race-category/race-race-category.module": [
		"./src/app/race/race-race-category/race-race-category.module.ts",
		"common",
		"race-race-category.module"
	],
	"./race-race-owner/race-race-owner.module": [
		"./src/app/race/race-race-owner/race-race-owner.module.ts",
		"common",
		"race-race-owner.module"
	],
	"./race-race-style/race-race-style.module": [
		"./src/app/race/race-race-style/race-race-style.module.ts",
		"common"
	],
	"./race-race/race-race.module": [
		"./src/app/race/race-race/race-race.module.ts",
		"common",
		"race-race.module"
	],
	"./race-track-type/race-track-type.module": [
		"./src/app/race/race-track-type/race-track-type.module.ts",
		"common",
		"race-track-type.module"
	],
	"./race-trainer/race-trainer.module": [
		"./src/app/race/race-trainer/race-trainer.module.ts",
		"common",
		"race-trainer.module"
	],
	"./race/race.module": [
		"./src/app/race/race.module.ts",
		"common",
		"race.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main